﻿import { useQuery } from 'react-query';

import GroupService from 'services/group.service';

export function useGetGroups(params, options) {
  return useQuery(['groups', params], () => GroupService.get(params), options);
}
